var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5928 15.5834C13.7635 15.4116 13.8594 15.1793 13.8594 14.9371C13.8594 14.695 13.7635 14.4626 13.5928 14.2909L10.3478 11.0001L13.5928 7.75505C13.7635 7.58331 13.8594 7.35097 13.8594 7.1088C13.8594 6.86663 13.7635 6.6343 13.5928 6.46255C13.5076 6.37664 13.4062 6.30844 13.2945 6.2619C13.1828 6.21537 13.063 6.19141 12.942 6.19141C12.821 6.19141 12.7012 6.21537 12.5895 6.2619C12.4777 6.30844 12.3764 6.37664 12.2911 6.46255L8.40448 10.3492C8.31856 10.4344 8.25037 10.5358 8.20383 10.6475C8.15729 10.7592 8.13333 10.879 8.13333 11.0001C8.13333 11.1211 8.15729 11.2409 8.20383 11.3526C8.25037 11.4643 8.31856 11.5657 8.40448 11.6509L12.2911 15.5834C12.3764 15.6693 12.4777 15.7375 12.5895 15.784C12.7012 15.8306 12.821 15.8545 12.942 15.8545C13.063 15.8545 13.1828 15.8306 13.2945 15.784C13.4062 15.7375 13.5076 15.6693 13.5928 15.5834Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleLeft);
export default __webpack_public_path__ + "static/media/angle-left.7ba3e44ee1fa7cd7dc324aa6da55d89e.svg";
export { ForwardRef as ReactComponent };